"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var react_router_1 = require("react-router");
var track_purchase_1 = require("@reverbdotcom/commons/dist/components/track_purchase");
var core_client_1 = require("../lib/core_client");
var url_helpers_1 = require("../components/shared/url_helpers");
var is_node_1 = require("@reverbdotcom/commons/dist/is-node");
var lodash_1 = require("lodash");
var mparticle_tracker_1 = require("@reverbdotcom/commons/dist/elog/mparticle_tracker");
var CART_URI = 'cart';
var CHECKOUT_CONFIRMATION_URI = 'multi-checkout/:order_bundle_id/confirmation';
var CHECKOUT_SHIPPING_URI = 'multi-checkout/:checkout_id/:payment_method';
var CHECKOUT_PAYMENT_URI = 'multi-checkout/:checkout_id/:payment_method/payment';
var CHECKOUT_REVIEW_URI = 'multi-checkout/:checkout_id/:payment_method/review';
var CHECKOUT_CHANGE_SHIPPING_URI = 'multi-checkout/:checkout_id/:payment_method/change_shipping';
var CHECKOUT_CHANGE_PAYMENT_URI = 'multi-checkout/:checkout_id/:payment_method/change_payment';
var CHECKOUT_ORDER_BUNDLE_CONFIRMATION_URI = 'multi-checkout/:checkout_id/:payment_method/:order_bundle_id/confirmation';
// we mount the router globally on bundled checkout pages. This catch-all route prevents 404 errors in RRE
// for routes that we don't need to track.
var CHECKOUT_NO_OP_URI = 'multi-checkout/*';
var CART_NO_OP_URI = 'cart/*';
var VALID_URI_PAYMENT_METHODS = Object.freeze([
    'direct',
    'paypal',
    'affirm',
    'partial_payments',
    'vaulted_paypal',
    'sofort',
]);
var PAYMENT_METHOD_FROM_URI = {
    direct: 'direct_checkout',
    paypal: 'paypal',
    affirm: 'affirm',
    vaulted_paypal: 'paypal',
    sofort: 'sofort',
};
function isTrackableRoute(params) {
    var paymentMethod = params.payment_method;
    return !paymentMethod || VALID_URI_PAYMENT_METHODS.indexOf(paymentMethod) > -1;
}
function cartItemsForPaymentMethod(cartItems, paymentMethod) {
    if (!paymentMethod)
        return cartItems;
    return cartItems.filter(function (item) { return item.payment_methods.hasOwnProperty(paymentMethod); });
}
function getTotal(cartItems, key) {
    return lodash_1.sumBy(cartItems, function (item) {
        return item[key] && parseFloat(item[key].amount) || 0;
    });
}
function buildCheckoutAttributes(responseCartItems, paymentMethod) {
    var cartItems = cartItemsForPaymentMethod(responseCartItems, paymentMethod);
    var itemTotalPrice = getTotal(cartItems, 'item_price');
    var shippingTotalPrice = getTotal(cartItems, 'shipping_price');
    var negotiatedOrder = lodash_1.some(cartItems, { type: 'offer' });
    return {
        itemCount: cartItems.length,
        totalPrice: (itemTotalPrice + shippingTotalPrice).toFixed(2),
        totalShippingRate: shippingTotalPrice.toFixed(2),
        paymentMethod: paymentMethod.toUpperCase(),
        'negotiatedOrder?': negotiatedOrder,
    };
}
exports.buildCheckoutAttributes = buildCheckoutAttributes;
var PAGE_NAMES = Object.freeze((_a = {},
    _a[CART_URI] = mparticle_tracker_1.MParticlePageName.Cart,
    _a[CHECKOUT_SHIPPING_URI] = mparticle_tracker_1.MParticlePageName.Shipping,
    _a[CHECKOUT_PAYMENT_URI] = mparticle_tracker_1.MParticlePageName.Payment,
    _a[CHECKOUT_REVIEW_URI] = mparticle_tracker_1.MParticlePageName.ReviewOrder,
    _a[CHECKOUT_CHANGE_SHIPPING_URI] = mparticle_tracker_1.MParticlePageName.ChangeShipping,
    _a[CHECKOUT_CHANGE_PAYMENT_URI] = mparticle_tracker_1.MParticlePageName.ChangePayment,
    _a));
function buildCheckoutPageView(params, route) {
    if (is_node_1.default) {
        return;
    }
    var routePath = route.path;
    var pageName = PAGE_NAMES[routePath];
    if (!pageName)
        return;
    var paymentMethod = PAYMENT_METHOD_FROM_URI[params.payment_method] || '';
    var headers = {
        'X-Display-Currency': 'USD',
    };
    return core_client_1.default.get(url_helpers_1.default.apiCartPath, { headers: headers }).then(function (response) {
        return tslib_1.__assign({ pageName: pageName }, buildCheckoutAttributes(response.cart_items, paymentMethod));
    });
}
function checkoutPageViewAttributes(params, route) {
    if (!isTrackableRoute(params))
        return;
    return buildCheckoutPageView(params, route);
}
exports.checkoutPageViewAttributes = checkoutPageViewAttributes;
var CHECKOUT_URIS = Object.freeze([
    CART_URI,
    CHECKOUT_SHIPPING_URI,
    CHECKOUT_PAYMENT_URI,
    CHECKOUT_REVIEW_URI,
    CHECKOUT_CHANGE_SHIPPING_URI,
    CHECKOUT_CHANGE_PAYMENT_URI,
]);
var CONFIRMATION_ROUTES = [
    React.createElement(react_router_1.Route, { key: CHECKOUT_CONFIRMATION_URI, path: CHECKOUT_CONFIRMATION_URI, getComponent: function (_location, cb) {
            cb(null, track_purchase_1.default);
        } }),
    React.createElement(react_router_1.Route, { key: CHECKOUT_ORDER_BUNDLE_CONFIRMATION_URI, path: CHECKOUT_ORDER_BUNDLE_CONFIRMATION_URI, getComponent: function (_location, cb) {
            cb(null, track_purchase_1.default);
        } }),
];
var NO_OP_ROUTES = [
    React.createElement(react_router_1.Route, { key: CHECKOUT_NO_OP_URI, path: CHECKOUT_NO_OP_URI }),
    React.createElement(react_router_1.Route, { key: CART_NO_OP_URI, path: CART_NO_OP_URI }),
];
var CHECKOUT_ROUTES = CHECKOUT_URIS.map(function (route) {
    return (React.createElement(react_router_1.Route, { key: route, path: route, props: {
            pageViewEvent: function (_a) {
                var params = _a.params, innerRoute = _a.innerRoute;
                return checkoutPageViewAttributes(params, innerRoute);
            },
        } }));
});
var ALL_CHECKOUT_ROUTES = tslib_1.__spreadArrays(CONFIRMATION_ROUTES, CHECKOUT_ROUTES, NO_OP_ROUTES);
exports.default = ALL_CHECKOUT_ROUTES;
//# sourceMappingURL=checkout.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/routes/checkout.js
// module id = JEae
// module chunks = 20 21